import { vservice } from '@niknevis/vue-modules'
import RouteBase from '@niknevis/vue-modules/abstracts/RouteBase'

@vservice()
export class AdminWalletLogRoute extends RouteBase {
  prefix = 'admin.users.'

  walletLogs(params: Record<string, string | number | boolean>) {
    return this.ziggyRoute('wallet_logs', params)
  }
}
